import { Controller } from "stimulus";
import { openDisclosure, toggleDisclosure, closeOverlay, isOpen } from "../../training_grooming_calendar/overlay";
import { resetDetail } from "../../training_grooming_calendar/url_state";
import { COLLAPSED, toggleSection, sectionsAfterChange, claimReopen, menuMaxHeight } from "../../training_grooming_calendar/filter_sections";

let pending = null;
let sections = COLLAPSED;

function selectedFacility(menu) {
  const option = menu.querySelector('[data-name="facility"][aria-selected="true"]');
  return option ? option.dataset.value : null;
}

export default class extends Controller {
  static targets = ["button", "menu"];

  connect() {
    const loaded = this.element.closest("[data-tg-load-reason]");
    const claim = claimReopen(pending, loaded ? loaded.dataset.tgLoadReason : null);
    pending = null;
    sections = claim.sections;
    this.applySections();
    if (!claim.open) return;
    this.open();
    const focus = claim.focusKey && this.menuTarget.querySelector(`[data-focus-key="${claim.focusKey}"]`);
    if (focus) focus.focus({ preventScroll: true });
  }

  disconnect() {
    if (isOpen(this.menuTarget)) closeOverlay({ restoreFocus: false });
  }

  toggle() {
    if (toggleDisclosure(this.disclosure())) this.fitMenu();
  }

  open() {
    openDisclosure(this.disclosure());
    this.fitMenu();
  }

  fitMenu() {
    if (this.element.classList.contains("tg-filters-sheet")) return;
    const top = this.menuTarget.getBoundingClientRect().top;
    this.menuTarget.style.setProperty("--tg-filters-max", `${menuMaxHeight({ top, viewport: window.innerHeight })}px`);
  }

  disclosure() {
    return {
      element: this.menuTarget,
      trigger: this.buttonTarget,
      root: this.element.closest(".tg"),
      sheet: this.element.classList.contains("tg-filters-sheet"),
      triggerClass: "tg-filters-open",
    };
  }

  close() {
    closeOverlay();
  }

  pick(event) {
    const { name, value } = event.currentTarget.dataset;
    this.menuTarget.querySelectorAll(`[data-name="${name}"]`).forEach((option) => option.setAttribute("aria-checked", option.dataset.value === value ? "true" : "false"));
    sections = sectionsAfterChange(sections, name);
    this.change(event.currentTarget, name === "service" ? "services-summary" : undefined);
  }

  toggleSection(event) {
    const section = event.currentTarget.dataset.sectionToggle;
    sections = toggleSection(sections, section);
    this.applySections();
    const toggle = this.menuTarget.querySelector(`.tg-filters-change[data-section-toggle="${section}"]`);
    if (toggle) toggle.focus({ preventScroll: true });
  }

  applySections() {
    this.element.querySelectorAll("[data-filters-section]").forEach((element) => {
      const open = !!sections[element.dataset.filtersSection];
      element.classList.toggle("tg-section-open", open);
      element.querySelectorAll("[data-section-toggle]").forEach((toggle) => toggle.setAttribute("aria-expanded", open ? "true" : "false"));
    });
  }

  flip(event) {
    const toggle = event.currentTarget;
    toggle.setAttribute("aria-checked", toggle.getAttribute("aria-checked") === "true" ? "false" : "true");
    this.change(toggle);
  }

  pickFacility(event) {
    const value = event.currentTarget.dataset.value;
    this.menuTarget.querySelectorAll('[data-name="facility"]').forEach((option) => option.setAttribute("aria-selected", option.dataset.value === value ? "true" : "false"));
    this.change(event.currentTarget, "facility");
  }

  clearCategories(event) {
    this.menuTarget.querySelectorAll('[data-name="category"]').forEach((option) => option.setAttribute("aria-checked", "false"));
    this.change(event.currentTarget);
  }

  resetAll() {
    sections = COLLAPSED;
    pending = { focusKey: "lanes-all", sections };
    this.element.dispatchEvent(new CustomEvent("training-grooming-filters:change", { bubbles: true, detail: resetDetail() }));
  }

  resetOrder(event) {
    pending = { focusKey: "lanes-all", sections };
    event.currentTarget.dispatchEvent(new CustomEvent("training-grooming-filters:reset-order", { bubbles: true }));
  }

  change(source, focusKey = source.dataset.focusKey) {
    const picked = (name) => this.menuTarget.querySelector(`[data-name="${name}"][aria-checked="true"]`);
    const on = (name) => picked(name) !== null;
    const detail = {
      lanes: picked("lanes").dataset.value,
      service: picked("service").dataset.value,
      blocks: on("blocks") ? "show" : "hide",
      schedules: on("schedules") ? "show" : "hide",
      scheduled: on("scheduled") ? "only" : "all",
      facility: selectedFacility(this.menuTarget),
      categories: Array.from(this.menuTarget.querySelectorAll('[data-name="category"][aria-checked="true"]')).map((option) => option.dataset.value),
    };
    pending = { focusKey, sections };
    this.element.dispatchEvent(new CustomEvent("training-grooming-filters:change", { bubbles: true, detail }));
  }
}
